<template>
    <!-- <slot>No address ... </slot> -->
    <div id="map">
        <div id="popup-map">
            <slot name="popup">No address selected...</slot>
        </div>
    </div>
</template>

<script>
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

// bug leaflet with webpack
// cf https://github.com/Leaflet/Leaflet/issues/4968#issuecomment-319569682
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'
import iconUrl from 'leaflet/dist/images/marker-icon.png'

L.Marker.prototype.options.icon = L.icon({
  iconUrl,
  shadowUrl,
  iconSize: [30, 42], // size of the icon
  iconAnchor: [15, 42], // point of the icon which will correspond to marker's location
  popupAnchor: [0, -42], // point from which the popup should open relative to the iconAnchor
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41],
  shadowAnchor: [11, 41]
})
    
export default {
    props: {
        coordinates:{
            type: Array,
            default: () => ([])
        },
        currentCoordinate: {
            type: Object
        }
    },
    data () {
        return {
            map: null
        }
    },
   mounted () {
    this.map = L.map('map').setView([51.505, -0.09], 13);


    // L.tileLayer('http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png', {
    // // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    //     attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    // }).addTo(this.map);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    }).addTo(this.map);

    L.marker([51.5, -0.09]).addTo(this.map)
        .bindPopup('No address <br> selected.')
        .openPopup();
   },
   watch: {
    coordinates (newValue) {
    newValue.forEach(value => {
        L.marker(value.geometry.coordinates).addTo(this.map)
    })
    },
    currentCoordinate (newValue){
    this.map.panTo(newValue.geometry.coordinates)
    }
   }
}
</script>

<style scoped>
    #map {height: 450px;}
</style>

<style scoped>
#map {
  height: 360px;
  position: relative;
}

#popup-map {
  z-index: 10000;
  width: 200px;
  border: 1px solid grey;
  position: absolute;
  background-color: white;
  padding: 1.5rem;
  border-radius: 30px;
  bottom: 0.5rem;
  left: calc(25% - 150px);
}

</style>
